/**
 * Reenvío del fragmento de un enlace de acceso a su ruta canónica.
 *
 * Módulo puro, sin componentes: exportarlo junto a un componente rompe el fast
 * refresh de Vite, que solo recarga limpiamente cuando el archivo exporta
 * componentes. Por eso vive aparte de `LegacyAliasRedirect` y es trivial de
 * testear sin montar el árbol de rutas.
 */

/**
 * `<Navigate to="/set-password">` descarta el hash: el token vive ahí, y sin él
 * un correo antiguo con `/establecer-contrasena#token=…` llegaría a una pantalla
 * de "enlace no válido" que empuja a pedir uno nuevo sin motivo.
 *
 * Sin prefijo `#` se añade: un hash suelto no sería un fragmento y la página de
 * destino lo leería como `null`. Sin `token=` no se reenvía nada, para no llevar a
 * una pantalla de error un enlace que solo traía un ancla de sección.
 *
 * `to` es la ruta canónica de destino y se pasa explícita: los alias no cubren
 * una sola pantalla, sino varias, y cada una tiene su canónica.
 */
export function withHashToken(hash: string, to: string): string {
  if (!hash || !hash.includes('token=')) return to;
  return `${to}${hash.startsWith('#') ? hash : `#${hash}`}`;
}
